<template>
  <hic-dialog :close-on-click-modal="true" :visible="visible" @open="open" @close="cancel" append-to-body title="质控规则" width="60rem" top="1.5rem">
    <el-container style="height: 35rem">
      <el-header>
        <el-button type="primary" size="small" @click="create" icon="el-icon-plus">新 增</el-button>
      </el-header>
      <el-main>
        <el-table @filter-change="filterChange" @sort-change="sortChange" :data="entities.items" stripe height="100%" v-loading="meta.loading">
          <el-table-column label="操作" align="center" width="120">
            <template slot-scope="{ row }">
              <el-button title="编辑" type="primary" plain size="mini" circle icon="el-icon-edit" @click="edit(row)"></el-button>
              <el-popconfirm title="确定要删除吗？" @confirm="del(row)" class="left-pad">
                <el-button slot="reference" title="删除" type="danger" plain size="mini" circle icon="el-icon-delete"></el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
          <el-table-column column-key="qcType" :filters="dictEnum.MrQCType" :filter-multiple="false" label="类型" width="120" prop="qcType" align="center"></el-table-column>
          <el-table-column label="问题描述" prop="content"></el-table-column>
          <el-table-column column-key="errLevel" :filters="dictEnum.MrQCErrLevel" :filter-multiple="false" label="问题级别" width="120" prop="errLevel" align="center"></el-table-column>
          <el-table-column label="时限(小时)" prop="timeLimit" align="right" width="100"></el-table-column>
          <el-table-column column-key="disabled" :filters="$utils.Dict.bool()" :filter-multiple="false" label="停用" prop="sizeDate" align="center" width="60">
            <template slot-scope="{ row }">
              <el-tag type="danger" v-if="row.disabled" size="mini" hit>是</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer class="center">
        <el-pagination
          v-if="entities.items && entities.items.length"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          @size-change="page"
          @current-change="page"
          :current-page.sync="condition.pageIndexOnView"
          :page-size.sync="condition.pageSize"
          :total="entities.total"
        />
      </el-footer>
    </el-container>
    <Editor @saved="page" :value="entity" :visible.sync="meta.showEditor" />
  </hic-dialog>
</template>

<script>
  import { mapGetters } from "sw-hic";
  export default {
    components: {
      Editor: () => import("./ruleEditor"),
    },
    props: {
      visible: Boolean,
    },
    data() {
      return {
        meta: {
          loading: false,
          showEditor: false,
        },
        entity: {},
        entities: {},
        condition: {
          sort: "id",
          asc: false,
          pageIndex: 0,
          pageSize: 10,
        },
      };
    },
    computed: {
      ...mapGetters(["dict", "Enum", "dictEnum"]),
    },
    methods: {
      open() {
        this.page();
      },
      cancel() {
        this.$emit("close");
        this.$emit("update:visible", false);
      },
      page() {
        this.meta.loading = true;
        this.$api.QcRule.query(this.condition)
          .then((res) => {
            this.entities = res;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      filterChange(obj) {
        let key = Object.keys(obj)[0];
        let value = obj[key][0];
        this.condition[key] = value;
        this.page();
      },
      sortChange(obj) {
        this.condition.sort = obj.column.property;
        this.condition.asc = obj.column.order.indexOf("asc") > -1 ? true : false;
        this.page();
      },
      create() {
        this.entity = {disabled: false};
        this.meta.showEditor = true;
      },
      edit(row) {
        this.entity = this.$utils.Obj.clone(row);
        this.meta.showEditor = true;
      },
      del(row) {
        this.$api.QcRule.del(row.id)
          .then((res) => {
            this.$message.success("删除成功");
            this.page();
          })
          .catch((err) => {
            this.$message.error(err);
          });
      },
    },
  };
</script>
